import fetch from 'utils/fetch'
export function uploadReagent (data) {
  return fetch({
    url: `/project/upload/reagent`,
    method: 'post',
    data
  })
}
export function uploadSample (data) {
  return fetch({
    url: `/project/upload/confirmExcelUploadBatch`,
    method: 'post',
    data
  })
}
export function uploadExperiment (data) {
  return fetch({
    url: `/project/upload/experiment`,
    method: 'post',
    data
  })
}
export function uploadAll (data) {
  return fetch({
    url: `/project/upload/all`,
    method: 'post',
    data
  })
}
export function downReagent (data) {
  return fetch({
    url: `/project/upload/downloadReagentTemplate`,
    method: 'post',
    data
  })
}
export function downSample (data) {
  return fetch({
    url: `/project/upload/createBlankSampleTemplate`,
    method: 'post',
    data
  })
}
export function chooseSamTem (data) {
  return fetch({
    url: `/project/upload/createSampleTemplateFromId`,
    method: 'post',
    data
  })
}
// raw File 上传
export function uploadRawFile (data) {
  return fetch({
    url: `${process.env.DATA_RAW_API}/data/file-management/uploadRawFile`,
    method: 'post',
    data
  })
}
export function replaceRawFile (data) {
  return fetch({
    url: `${process.env.DATA_RAW_API}/data/file-management/replaceRawFile`,
    method: 'post',
    data
  })
}
export function downloadRawFile (data) {
  return fetch({
    url: `${process.env.DATA_RAW_API}/data/file-management/downloadRawFile`,
    method: 'post',
    data
  })
}
export function getRawFileList (data) {
  return fetch({
    url: `${process.env.DATA_RAW_API}/data/file-management/getRawFileList`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/upload.js